import { render, staticRenderFns } from "./DocDown.vue?vue&type=template&id=2421a076&scoped=true&"
import script from "./DocDown.vue?vue&type=script&lang=js&"
export * from "./DocDown.vue?vue&type=script&lang=js&"
import style0 from "./DocDown.vue?vue&type=style&index=0&id=2421a076&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2421a076",
  null
  
)

export default component.exports